import { ILocalizationState } from "./localization.types";

export const localizationInitialState: ILocalizationState = {
  selectedKey: (localStorage.getItem("language") as "en" | "es") || "es",
  isInit: false,
  enabled: [],
  localizations: {},
};
